(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["Custom-SLider"] && !window.DesignMode) return;
  try {
    


window.onload = function()
				{
					flickity();
				}
function flickity()
{
	console.log("Initiating Flickity");
	 $('.main_slider_container').flickity({
                                  // options
                                  cellAlign: 'left',
                                  contain: true,
                                  wrapAround: true,
                                  //freeScroll: true,
								  prevNextButtons: false,
								  autoPlay:4500,
                                  arrowShape: { 
                                          x0: 10,
                                          x1: 60, y1: 50,
                                          x2: 60, y2: 40,
                                          x3: 20
                                        }
                                 
                                });
}

  } catch(e) { console.error(e); }
})();

})();
